<template>
  <div class="home">
    <div style="top:10px;position:absolute;left:10px;">
      <el-button type="primary" @click="back" plain>后退</el-button>
      <el-button type="primary" @click="page" plain>Settings</el-button>
    </div>
    <!-- <div style="top:60px;position:absolute;right:10px;">
      <el-button type="primary" icon="el-icon-s-data" @click="schedule" plain>快反日程表</el-button>
    </div>
    <div style="top:10px;position:absolute;right:10px;">
      <el-button type="primary" icon="el-icon-s-data" @click="d8Report" plain>统计&nbsp;报表</el-button>
    </div> -->
    <div class="content">
      <el-row :gutter="12">
        <!-- <el-col :span="24" >
          <el-button @click="groupClick()" size="medium">分段看板</el-button>
        </el-col> -->
        <el-col :span="24" v-for="(item,i) in listData" :key="i">
          <el-button size="medium" @click="typeClick(item)">{{item.title}}</el-button>
        </el-col>
        <el-col :span="24" v-if="listData.length<1">
          <el-button size="medium">快反流程空白</el-button>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="设置"
      width="380px"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="80px">
        <el-form-item label="每页显示">
          <el-input @input="pageChange" v-model="ruleForm.pageSize">
            <template slot="append">条</template>
          </el-input>
        </el-form-item>
        <el-form-item label="数据切换">
          <el-input @input="tooChange" v-model="ruleForm.too">
            <template slot="append">秒</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setUp('ruleForm')">确认</el-button>
          <el-button @click="defaultUp()">默认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../../router";
export default {
  name: "home",
  data() {
    return {
      msg: "home",
      first: null,
      version:"1.0",
      dialogFormVisible: false,
      pageSize: 40,
      too: 10,
      listData: [],
      ruleForm: {
        pageSize: 40,
        too: 10
      }
    };
  },
  mounted() {
    // 初始化
    this.init();
  },
  methods: {
    schedule(){
      this.$router.push({
        path: "/fr/schedule"
      });
    },
    d8Report() {
      this.$router.push({
        path: "/fr/report"
      });
    },
    typeClick(data) {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: data.uuid,
          toConfirm: data.toConfirm,
          title:data.title
        }
      });
    },
    groupClick() {
      this.$router.push({
        path: "/fr/groups",
        query: {
          key: '297e8f698359f2de01835a04e04c0001'
        }
      });
    },
    back() {
      router.back();
    },

    pageChange(value) {
      if (isNaN(value)) {
        value = parseInt(value);
        this.ruleForm.pageSize = isNaN(value) ? this.pageSize : value;
      }
    },

    tooChange(value) {
      if (isNaN(value)) {
        value = parseInt(value);
        this.ruleForm.too = isNaN(value) ? this.too : value;
      }
    },

    page() {
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.ruleForm.pageSize = setUp["pageSize"];
        this.ruleForm.too = setUp["too"];
      }
      this.dialogFormVisible = true;
    },

    setUp() {
      var pageSize = this.ruleForm.pageSize;
      var too = this.ruleForm.too;
      var setUp = { pageSize: pageSize, too: too };
      localStorage.setItem("setUp", JSON.stringify(setUp));
      this.dialogFormVisible = false;
    },

    defaultUp() {
      this.ruleForm.pageSize = this.pageSize;
      this.ruleForm.too = this.too;
    },

    init() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);

        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        const params = {
          Expanded: "",
          Selectable: ""
        };
        API.listTree(params)
          .then(res => {
            console.log(res);
            if (res.success === true) {
              this.listData = res.list;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/category/category.vue